<script setup lang="ts">
import {
  tpgIconClose,
  tpgIconMap,
} from '@tpg/grammar-web-icons';

import {
  GrammarOverlayCard,
  GrammarQuaternaryButton,
  GrammarSectionHeader,
} from '@nora-monorepo/grammar-ui';
import { DrawToolType } from '@nora-monorepo/nora-api-client';

import SymbolFavourites from '#nora-ui/map/components/drawtools/symbol-tool/SymbolFavourites.vue';
import ToolListItem from '#nora-ui/map/components/drawtools/tool-list/ToolListItem.vue';
import { useMapStore } from '#nora-ui/map/stores/map-store';

interface Props {
  mapId: string;
}

const props = defineProps<Props>();
const { mapId } = props;
const mapStore = useMapStore();
const map = mapStore.getMapByIdOrThrow(mapId);
const drawToolUI = map.drawToolUI;

const drawCategory: DrawToolType[] = [
  DrawToolType.line,
  DrawToolType.polygon,
  DrawToolType.circle,
  DrawToolType.freehand,
  DrawToolType.tactical_annotation,
];
const mapCategory: DrawToolType[] = [
  DrawToolType.ruler,
  DrawToolType.route,
  DrawToolType.text,
  DrawToolType.spot,
];

function onClose() {
  drawToolUI.isToolListOpen.value = false;
}
</script>

<template>
  <GrammarOverlayCard
    class="w-[288px] override-min-width pointer-events-auto"
    :leading-icon-template="tpgIconMap"
    heading-label="Draw and map tools"
  >
    <template #header-trailing-buttons>
      <GrammarQuaternaryButton
        :icon-template="tpgIconClose"
        @click="onClose"
      />
    </template>
    <div class="flex flex-col items-center pb-4">
      <SymbolFavourites
        :map-id="mapId"
        :list-view="true"
      />
      <div>
        <GrammarSectionHeader
          label="Draw"
          header-type="form-header"
        />
        <div class="grid grid-cols-5 gap-2 justify-center">
          <ToolListItem
            v-for="drawToolType of drawCategory"
            :key="drawToolType"
            :draw-tool-type="drawToolType"
            :map-id="mapId"
          />
        </div>
      </div>
      <div>
        <GrammarSectionHeader
          label="Map tools"
          header-type="form-header"
        />
        <div class="grid grid-cols-5 gap-2 justify-center">
          <ToolListItem
            v-for="drawToolType of mapCategory"
            :key="drawToolType"
            :draw-tool-type="drawToolType"
            :map-id="mapId"
          />
        </div>
      </div>
    </div>
  </GrammarOverlayCard>
</template>
